module.exports = __webpack_public_path__ + "img/20190813.850dcd1f.png";